<template lang="pug">
section
  s-page-title(:previous='true' :title='complex.complex_name' subtitle='Жилые комплексы')
    template(slot='extension')
      s-sort-button(@click='sorting.opened = true' class='mr-3')
      v-btn(@click='onAdd' color='primary' depressed) Добавить
  v-container(class='pa-0 mb-5' grid-list-xl fluid)
    v-layout(row wrap)
      v-flex(v-for='object in filteredList' :key='object.id' xs12 sm6 md4 lg3 xl3)
        card(:object='object' @click='onShow' @edit='onEdit' @btilayouts='onEditBti' @remove='onRemove')
  s-sorting-list(v-model='sorting' @sort-success='fetch')
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Card from './Card'
import { filter } from 'lodash'

export default {
  props: ['id'],

  components: {
    Card
  },

  data: function() {
    return {
      sorting: {
        opened: false,
        resource: 'complexes/objects',
        itemValue: 'id',
        itemText: 'object_name',
        params: { complex_id: this.id }
      }
    }
  },

  created() {
    this.fetch()
  },

  methods: {
    async fetch() {
      try {
        await this.fetchList({
          config: {
            params: {
              complex_id: this.id,
              show_info: true
            }
          }
        })
      } catch (e) {
        this.$root.showSnack('Ошибка загрузки списка объектов')
      }
    },

    async onRemove({ id }) {
      if (await this.$confirm('Удалить объект?')) {
        try {
          await this.destroy({ id })
        } catch (e) {
          this.$showServerErrors(e)
        }
        this.fetch()
      }
    },

    onAdd() {
      this.$router.push({
        name: 'Complexes.Objects.Edit',
        params: { id: this.id }
      })
    },

    onShow({ id, complex_id }) {
      this.$router.push({
        name: 'Complexes.Objects.Sections',
        params: {
          id: complex_id,
          objectId: id
        }
      })
    },
    onEdit({ id }) {
      this.$router.push({
        name: 'Complexes.Objects.Edit',
        params: {
          id: this.id,
          objectId: id
        }
      })
    },
    onEditBti({ id }) {
      this.$router.push({
        name: 'Complexes.Objects.Bti',
        params: {
          id: this.id,
          objectId: id
        }
      })
    },

    ...mapActions('objects/objects', ['fetchList', 'destroy'])
  },

  computed: {
    filteredList() {
      return filter(this.list, { complex_id: +this.id })
    },

    complex() {
      return this.complexById(this.id)
    },

    ...mapGetters('objects/objects', [
      'filter',
      'isLoading',
      'complexById',
      'list'
    ])
  }
}
</script>
